<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6">
        <v-card-title class="mt-4">
          <v-btn class="mr-2" fab x-small color="#6c5dd4" @click="$router.back()">
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn>Edit Value
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="12">
              <v-col sm="6">
                <v-text-field @input="form.name = form.name ? form.name.toUpperCase() : ''" v-model="form.name" outlined label="Name"
                  prepend-inner-icon="mdi-card-text-outline"></v-text-field>
              </v-col>
            </v-col>
            <v-col>
              <v-btn class="float-end" :loading="isLoading" color="#6c5dd4" dark @click="save">
                Update Value
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "ValueEditPage",
  data() {
    return {
      form: {},
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let form = await axios.get(`/values/${this.$route.params.valueId}`);
      this.form = form.data.data;
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.patch(`/values/${this.$route.params.valueId}`, this.form);
        this.isLoading = false;
        this.$router.push("/values");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
